import React, { useEffect, useState } from "react";
import TetellistaItem from "./TetellistaItem";
import { ROUTES } from "../../../../constants/Routes";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StepBar from "../../../../components/calculator/Wizard/StepBar";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import BackButton from "../../../../components/calculator/ConditionLabel/BackButton";
import ArrowLeft from ".//..//..//..//..//assets//images//icons//arrow-left.svg";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { ProposalItemActions } from "../../../../store/Slice/ProposalItemSlice";
import Spinner from "../../../../components/common/Splnner/Spinner";

const KalkulacioTetellista = () => {
  const [step, setStep] = useState(4);
  const { getAuth, clearAuth } = useAuth();
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [proposalKey, setProposalKey] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const proposalId = searchParams.get("p-id");

  //--

  // --
  const dispatch = useDispatch();
  const proposalItems = useSelector((state) => state.proposalItems.proposalItems);

  const packingMaterialsInit = useSelector((state) => state.proposalItems.packingMaterialsInit);

  const fees = useSelector((state) => state.proposalItems.fees);

  console.log(fees[0]);
  const totalAmount = useSelector((state) => state.proposalItems.totalAmount);
  const totalCapacity = useSelector((state) => state.proposalItems.totalCapacity);

  //---

  const fetchProposalItems = () => {
    setSpinnerVisible(true);
    HttpHelper.GetWithOutSearchRequest({
      route: `${API_ROUTES.PR_TOURPLAN_ITEM_LIST}?proposal_id=${proposalId}`,
      token: getAuth()?.bearerToken,
    })
      .then((data) => {
        if (data.status == 200) {
          const zones = data?.data?.zones;
          const zoneItems = data?.data?.zoneItems;
          const proposalTourPlan = data?.data?.proposalTourPlan;
          const proposalItems = data?.data?.proposalItems;
          const fees = data?.data?.fees;
          const transactionFee = data?.data?.transactionFee;
          const packingMaterials = data?.data?.packingMaterials;
          const proposalPackingMaterials = data?.data?.proposalPackingMaterials;
          const proposalData = data?.data?.proposalData;
          setProposalKey(proposalData[0]?.proposal_number);
          console.log(proposalPackingMaterials);
          dispatch(
            ProposalItemActions.setproposalItemsInitial({
              zoneItems,
              proposalItems,
              zones,
              proposalTourPlan,
              fees,
              transactionFee,
              packingMaterials,
              proposalPackingMaterials,
            })
          );
          setSpinnerVisible(false);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
          setSpinnerVisible(false);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        toast.error("Unknown server error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSpinnerVisible(false);
      });
  };

  useEffect(() => {
    fetchProposalItems();
  }, []);

  const getMaterialsWithGegenstandGreaterThanZero = (materials) => {
    let filteredItems = [];

    materials.forEach((location) => {
      const filteredMaterials = location.materials.filter((material) => material.gegenstand > 0);

      if (filteredMaterials.length > 0) {
        filteredItems = [...filteredItems, ...filteredMaterials];
      }
    });

    return filteredItems;
  };

  const saveProposalItems = () => {
    const packingMaterials = getMaterialsWithGegenstandGreaterThanZero(packingMaterialsInit);

    const filteredItems = proposalItems.reduce((result, location) => {
      const filteredLocationItems = location.items.filter((item) => item.gegenstand > 0 || item.entladen > 0);

      if (filteredLocationItems.length > 0) {
        result = [...result, ...filteredLocationItems];
      }

      return result;
    }, []);

    setSpinnerVisible(true);
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_ITEM_SAVE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        proposalItems: filteredItems,
        packingMaterials,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          // reset();
          setSpinnerVisible(false);
          // refreshCustomerList();
          toast.success("Árajánlat tételek sikeresen mentve.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(`${ROUTES.CAL_MANAGE_LOGISTIC_DATA}?p-id=${proposalId}`);
        } else if (res.status === 422) {
          const messages = res.message;
          console.log(messages);
          setSpinnerVisible(false);
          toast.error("Hiba, Árajánlat tételek sikeresen nem lettek mentve", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          setSpinnerVisible(false);
          navigator(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        console.log(error);
        setSpinnerVisible(false);
        toast.error("Hiba, Árajánlat tételek sikeresen nem lettek mentve", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const saveProposalItems2 = () => {
    const packingMaterials = getMaterialsWithGegenstandGreaterThanZero(packingMaterialsInit);

    const filteredItems = proposalItems.reduce((result, location) => {
      const filteredLocationItems = location.items.filter((item) => item.gegenstand > 0 || item.entladen > 0);

      if (filteredLocationItems.length > 0) {
        result = [...result, ...filteredLocationItems];
      }

      return result;
    }, []);

    setSpinnerVisible(true);
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_ITEM_SAVE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        proposalItems: filteredItems,
        packingMaterials,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          // reset();
          setSpinnerVisible(false);
          // refreshCustomerList();
          toast.success("Árajánlat tételek sikeresen mentve.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 422) {
          const messages = res.message;
          console.log(messages);
          setSpinnerVisible(false);
          toast.error("Hiba, Árajánlat tételek sikeresen nem lettek mentve", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          setSpinnerVisible(false);
          navigator(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        console.log(error);
        setSpinnerVisible(false);
        toast.error("Hiba, Árajánlat tételek sikeresen nem lettek mentve", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      {/* Header Start */}
      <Spinner spinnerVisible={spinnerVisible}>
        <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem] gap-3 grid grid-cols-2 md:grid-cols-[10rem_1fr_10rem] grid-rows-2 md:grid-rows-1">
          <div className="col-start-1 col-end-2 row-start-2 row-end-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] me-auto">
              <Link to={`${ROUTES.CAL_MANAGE_ADDRESS_DATA}?p-id=${proposalId}`}>
                <BackButton icon={ArrowLeft} label={"Vissza"} />
              </Link>
            </div>
          </div>
          <div className="w-full col-span-2 md:col-span-1 md:col-end-3 md:col-start-2 ">
            <StepBar currentStepNo={step} />
          </div>
          <div className="col-start-2 col-end-3 row-start-2 row-end-3 md:col-end-4 md:col-start-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] ms-auto">
              {/* <Link to={ROUTES.CAL_MANAGE_LOGISTIC_DATA}> */}
              <ButtonFluid label={"Mentés"} onClick={saveProposalItems} />
              {/* </Link> */}
            </div>
          </div>
        </div>
        {/* Header End */}
        <div className="px-[1rem] sm:px-[1.875rem] mt-[3.7rem] flex flex-col sm:items-center justify-between sm:flex-row gap-10">
          <div className="flex flex-row items-center justify-between gap-[1.5rem] w-full">
            <div className="flex flex-col">
              <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[2rem] font-bold leading-[2.5rem]">
                Ajánlat száma: {proposalKey}
              </span>
            </div>
            <div className="flex flex-row gap-10">
              <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[1.5rem] font-bold leading-[2.5rem]">
                Összesen: {totalAmount} EUR
              </span>
              <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[1.5rem] font-bold leading-[2.5rem]">
                Köbméter: {totalCapacity} m3
              </span>
            </div>
          </div>
        </div>
        <div className="mx-[1rem] px-[1rem]  mt-[3.7rem] gap-10  overflow-x-auto">
          <div className="flex flex-col gap-5">
            {proposalItems && (
              <>
                {proposalItems.slice(1).map((item, index) => (
                  <TetellistaItem key={index} item={item} index={index} saveProposalItems2={saveProposalItems2} />
                ))}
              </>
            )}
          </div>
        </div>
      </Spinner>
    </>
  );
};

export default KalkulacioTetellista;
